import axios from 'axios';
import Select2 from 'v-select2-component';

export default {
    components: {
        'select2': Select2
    },
    name: 'SelectAgent',
    props: {
        value: [Number],
        inputclass: {
            type: String,
            default: ''
        },
        emptyname: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            agents: []
        };
    },
    computed: {
        options() {
            return this.agents.map(x => {
                return { id: x.id, text: x.nameShort };
            });
        },
    },
    created() {
        this.fetch();
    },
    methods: {
        fetch() {
            axios.get(APIURL + '/shared/companies/companyagent')
                .then(resp => this.agents = resp.data);
        },
    }
};